export const ErrorCodes = {
  INVITATION_EXPIRED: 'invitation_expired',
  FORBIDDEN_REGISTRATION: 'forbidden_registration',
  HIGH_SCORE_USER: 'high_score_user',
  CONTEXTUAL_PARAMETERS_FAILURE: 'contextual_parameters_failure',
  INVALID_INVITATION: 'invalid_invitation',
};
